import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { loadUmami } from './umami.js'
import './index.css'

loadUmami() // no-op unless VITE_UMAMI_WEBSITE_ID is set (fixes the 400-spam bug)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
